export default {
  undo: {
    label: 'Undo',
    keys: ['super+z'],
    default: true,
    desc: 'Undo last change'
  },
  redo: {
    label: 'Redo',
    keys: ['super+shift+z'],
    default: true,
    desc: 'Resdo last undo'
  },
};
